/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_Not_ConfiguredInputs */

const cs_settings_meta_not_configured = /** @type {(inputs: Settings_Meta_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojení Meta zatím není na serveru nastavené. Požádejte správce o zapnutí Facebook/Instagram propojení.`)
};

const en_settings_meta_not_configured = /** @type {(inputs: Settings_Meta_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta connect is not set up on this server yet. Ask an admin to enable Facebook/Instagram.`)
};

/**
* | output |
* | --- |
* | "Meta connect is not set up on this server yet. Ask an admin to enable Facebook/Instagram." |
*
* @param {Settings_Meta_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_not_configured = /** @type {((inputs?: Settings_Meta_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_not_configured(inputs)
	return cs_settings_meta_not_configured(inputs)
});